export const AuthenticationStages = {
    REQUEST: 0,
    VERIFICATION: 1,
    AUTHENTICATED: 2
};
